import React, { useState, useRef, useEffect } from "react";
import { motion, AnimatePresence } from "framer-motion";
import { processarPergunta, obterSugestoes, melhorarResposta } from "../services/chatbotService";

const KaringanaBotWidget = () => {
  // Adicionar CSS para animação de carregamento
  useEffect(() => {
    const style = document.createElement('style');
    style.textContent = `
      @keyframes spin {
        0% { transform: rotate(0deg); }
        100% { transform: rotate(360deg); }
      }
    `;
    document.head.appendChild(style);
    return () => document.head.removeChild(style);
  }, []);
  const [open, setOpen] = useState(false);
  const [mensagem, setMensagem] = useState("");
  const messagesEndRef = useRef(null);
  const [showAllFaq, setShowAllFaq] = useState(false);
  const [historico, setHistorico] = useState([]);
  const [isProcessing, setIsProcessing] = useState(false);

  useEffect(() => {
    if (messagesEndRef.current) {
      messagesEndRef.current.scrollIntoView({ behavior: "smooth" });
    }
  }, [historico]);

  const toggleChat = () => setOpen(!open);

  const perguntar = async () => {
    if (!mensagem.trim() || isProcessing) return;
    
    const perguntaAtual = mensagem.trim();
    setIsProcessing(true);
    
    // Adicionar pergunta ao histórico
    const novaPergunta = {
      tipo: 'pergunta',
      texto: perguntaAtual,
      timestamp: new Date()
    };
    setHistorico(prev => [...prev, novaPergunta]);
    
    try {
      // Usar o novo serviço de chatbot inteligente
      const resultado = await processarPergunta(perguntaAtual);
      
      // Melhorar a resposta com contexto moçambicano
      const respostaMelhorada = melhorarResposta(resultado.resposta, perguntaAtual);
      
      // Adicionar resposta ao histórico
      const novaResposta = {
        tipo: 'resposta',
        texto: respostaMelhorada,
        fonte: resultado.fonte,
        confianca: resultado.confianca,
        timestamp: new Date()
      };
      setHistorico(prev => [...prev, novaResposta]);
    } catch (error) {
      console.error("Erro ao processar pergunta:", error);
      const erroResposta = {
        tipo: 'resposta',
        texto: "Desculpe, tive um problema técnico. Pode tentar novamente ou perguntar sobre cultura moçambicana, ecologia, ou geografia.",
        fonte: 'erro',
        confianca: 0.1,
        timestamp: new Date()
      };
      setHistorico(prev => [...prev, erroResposta]);
    } finally {
      setIsProcessing(false);
      setMensagem("");
    }
  };

  return (
    <>
      {/* Botão Flutuante */}
      <motion.button
        onClick={toggleChat}
        initial={{ opacity: 0, y: 50 }}
        animate={{ opacity: 1, y: 0 }}
        whileHover={{ scale: 1.1 }}
        style={{
          position: "fixed",
          bottom: "25px",
          right: "25px",
          backgroundColor: "#66BB6A",
          color: "white",
          border: "none",
          borderRadius: "50%",
          width: "60px",
          height: "60px",
          fontSize: "1.8rem",
          boxShadow: "0px 4px 15px rgba(0,0,0,0.3)",
          zIndex: 9999,
          cursor: "pointer",
        }}
        aria-label="Abrir chatbot"
      >
        🤖
      </motion.button>

      {/* Janela de Chat */}
      <AnimatePresence>
        {open && (
          <motion.div
            initial={{ opacity: 0, y: 50 }}
            animate={{ opacity: 1, y: 0 }}
            exit={{ opacity: 0, y: 50 }}
            style={{
              position: "fixed",
              bottom: "100px",
              right: "25px",
              width: "340px",
              maxWidth: "98vw",
              maxHeight: "75vh",
              background: "#fff",
              borderRadius: "16px",
              boxShadow: "0 8px 32px rgba(0,0,0,0.18)",
              padding: 0,
              zIndex: 10001,
              display: "flex",
              flexDirection: "column",
              overflow: "hidden",
              fontFamily: "inherit",
            }}
          >
            {/* Cabeçalho */}
            <div style={{
              background: "#388E3C",
              color: "#fff",
              padding: "14px 18px 12px 18px",
              display: "flex",
              alignItems: "center",
              justifyContent: "space-between",
              borderTopLeftRadius: "16px",
              borderTopRightRadius: "16px",
              fontWeight: 600,
              fontSize: "1.08rem",
              letterSpacing: "0.2px"
            }}>
              <span>KaringanaBot</span>
              <button
                onClick={toggleChat}
                style={{
                  background: "transparent",
                  border: "none",
                  color: "#fff",
                  fontSize: "1.3rem",
                  cursor: "pointer",
                  marginLeft: "8px"
                }}
                aria-label="Fechar chatbot"
              >
                ×
              </button>
            </div>

            {/* Área de mensagens/resposta */}
            <div style={{
              flex: 1,
              padding: "16px 16px 0 16px",
              overflowY: "auto",
              background: "#f8faf8",
              display: "flex",
              flexDirection: "column",
              gap: "10px"
            }}>
              <div style={{ color: "#666", fontSize: "13px", marginBottom: "2px" }}>
                🤖 KaringanaBot Inteligente - Especialista em cultura e ecologia moçambicana
              </div>
              
              {/* Sugestões de perguntas inteligentes */}
              <div style={{
                background: "#f1f8e9",
                borderRadius: "10px",
                border: "1px solid #d0e8d6",
                padding: "6px 4px 2px 4px",
                marginBottom: "2px"
              }}>
                <div style={{ fontWeight: "bold", marginBottom: "4px", fontSize: "12px", color: "#388E3C" }}>
                  💡 Perguntas sugeridas:
                </div>
                <div style={{ display: "flex", flexWrap: "wrap", gap: "5px" }}>
                  {(showAllFaq ? obterSugestoes() : obterSugestoes().slice(0, 3)).map((sugestao, idx) => (
                    <button
                      key={idx}
                      onClick={() => {
                        setMensagem(sugestao);
                        setTimeout(() => perguntar(), 100);
                      }}
                      style={{
                        background: "#e8f5e9",
                        border: "1px solid #b2dfdb",
                        borderRadius: "16px",
                        padding: "4px 10px",
                        fontSize: "11px",
                        cursor: "pointer",
                        color: "#388E3C",
                        fontWeight: 500,
                        boxShadow: "0 1px 2px rgba(56,142,60,0.05)",
                        transition: "background 0.2s, box-shadow 0.2s",
                        maxWidth: "100%",
                        whiteSpace: "normal"
                      }}
                      onMouseOver={e => e.currentTarget.style.background = '#c8e6c9'}
                      onMouseOut={e => e.currentTarget.style.background = '#e8f5e9'}
                    >
                      {sugestao}
                    </button>
                  ))}
                  {obterSugestoes().length > 3 && (
                    <button
                      onClick={() => setShowAllFaq(!showAllFaq)}
                      style={{
                        background: "#fff",
                        border: "1px solid #b2dfdb",
                        borderRadius: "16px",
                        padding: "4px 10px",
                        fontSize: "11px",
                        cursor: "pointer",
                        color: "#388E3C",
                        fontWeight: 500,
                        marginLeft: "2px"
                      }}
                    >
                      {showAllFaq ? "Ver menos" : "Ver mais"}
                    </button>
                  )}
                </div>
              </div>

              {/* Histórico de conversa */}
              <div style={{ flex: 1, display: "flex", flexDirection: "column", gap: "8px" }}>
                {historico.map((mensagem, idx) => (
                  <div
                    key={idx}
                    style={{
                      display: "flex",
                      justifyContent: mensagem.tipo === 'pergunta' ? 'flex-end' : 'flex-start',
                      marginBottom: "8px"
                    }}
                  >
                    <div
                      style={{
                        maxWidth: "80%",
                        padding: "10px 12px",
                        borderRadius: "12px",
                        fontSize: "14px",
                        lineHeight: "1.4",
                        wordWrap: "break-word",
                        ...(mensagem.tipo === 'pergunta' ? {
                          background: "#388E3C",
                          color: "white",
                          borderBottomRightRadius: "4px"
                        } : {
                          background: "#f1f1f1",
                          color: "#222",
                          borderBottomLeftRadius: "4px",
                          boxShadow: "0 1px 4px rgba(0,0,0,0.1)"
                        })
                      }}
                    >
                      {mensagem.texto}
                      {mensagem.tipo === 'resposta' && mensagem.fonte && (
                        <div style={{ 
                          fontSize: "10px", 
                          color: "#666", 
                          marginTop: "4px",
                          fontStyle: "italic"
                        }}>
                          Fonte: {mensagem.fonte === 'base_local' ? 'Base de Conhecimento' : 
                                  mensagem.fonte === 'api_hugging_face' ? 'IA Inteligente' : 
                                  mensagem.fonte === 'fallback' ? 'Resposta Geral' : 'Sistema'}
                        </div>
                      )}
                    </div>
                  </div>
                ))}
                
                {/* Indicador de carregamento */}
                {isProcessing && (
                  <div style={{
                    display: "flex",
                    justifyContent: "flex-start",
                    marginBottom: "8px"
                  }}>
                    <div style={{
                      background: "#f1f1f1",
                      color: "#222",
                      padding: "10px 12px",
                      borderRadius: "12px",
                      borderBottomLeftRadius: "4px",
                      fontSize: "14px",
                      display: "flex",
                      alignItems: "center",
                      gap: "8px"
                    }}>
                      <div style={{
                        width: "16px",
                        height: "16px",
                        border: "2px solid #388E3C",
                        borderTop: "2px solid transparent",
                        borderRadius: "50%",
                        animation: "spin 1s linear infinite"
                      }}></div>
                      Processando...
                    </div>
                  </div>
                )}
              </div>
              
              <div ref={messagesEndRef} />
            </div>

            {/* Campo de texto e botão de envio */}
            <form
              onSubmit={e => {
                e.preventDefault();
                perguntar();
              }}
              style={{
                display: "flex",
                alignItems: "center",
                gap: "8px",
                padding: "12px 14px 14px 14px",
                background: "#fff",
                borderBottomLeftRadius: "16px",
                borderBottomRightRadius: "16px",
                borderTop: "1px solid #f0f0f0"
              }}
            >
              <textarea
                rows="2"
                placeholder="Escreve a tua pergunta..."
                value={mensagem}
                onChange={(e) => setMensagem(e.target.value)}
                style={{
                  flex: 1,
                  padding: "9px 10px",
                  borderRadius: "8px",
                  border: "1px solid #ccc",
                  resize: "none",
                  fontFamily: "inherit",
                  fontSize: "15px",
                  boxSizing: "border-box",
                  minHeight: "36px",
                  maxHeight: "60px",
                  background: "#f8faf8"
                }}
              />
              <button
                type="submit"
                disabled={!mensagem.trim() || isProcessing}
                style={{
                  backgroundColor: !mensagem.trim() || isProcessing ? "#bdbdbd" : "#388E3C",
                  color: "white",
                  border: "none",
                  padding: "10px 18px",
                  borderRadius: "8px",
                  cursor: !mensagem.trim() || isProcessing ? "not-allowed" : "pointer",
                  fontWeight: "bold",
                  fontSize: "15px",
                  transition: "background 0.2s",
                  display: "flex",
                  alignItems: "center",
                  gap: "6px"
                }}
              >
                {isProcessing ? (
                  <>
                    <div style={{
                      width: "12px",
                      height: "12px",
                      border: "2px solid white",
                      borderTop: "2px solid transparent",
                      borderRadius: "50%",
                      animation: "spin 1s linear infinite"
                    }}></div>
                    Processando...
                  </>
                ) : (
                  "Enviar"
                )}
              </button>
            </form>
          </motion.div>
        )}
      </AnimatePresence>
    </>
  );
};

export default KaringanaBotWidget;
